/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { MDDEResult } from "@sa/rep-mdde";
import { useDictionary, useOLAPTransformer, yearToCropYearFull, OLAPTransformerResult } from "../../../shared";
import { dataService, dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe } from "../../../../charts/pipes";

const CATEGORIES_AXIS = "calendar.default";
const SERIES_AXIS = "commodities.default";

export function useData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, categoriesDictionary] = useDictionary(dictionaryService, "slides-calendar");
  const [, seriesDictionary] = useDictionary(dictionaryService, "commodities-harm");
  const options = useMemo(() => {
    if (!olapResult || !categoriesDictionary || !seriesDictionary) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsDictionaries: new Map([
        [CATEGORIES_AXIS, categoriesDictionary],
        [SERIES_AXIS, seriesDictionary],
      ]) as ReadonlyMap<string, Dictionary>
    }
  }, [olapResult, categoriesDictionary, seriesDictionary]);
  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${CATEGORIES_AXIS}.name`],
      rows: [`${SERIES_AXIS}.name`],
      cellData: {
        inCell: ["Measures.change"],
        attributes: [`${CATEGORIES_AXIS}.name`, `${SERIES_AXIS}.name`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
